import React from 'react'

export default function TextBody() {
  return (
    <div className='textBody'>
<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10743.980054044907!2d-117.446906!3d47.6845168!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xdcae4761eca6e8ca!2sRadio%20Bar%20Spokane!5e0!3m2!1sen!2sus!4v1667931578484!5m2!1sen!2sus" width="100%" height="100%" title='googlemap' allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
    </div>
  )
  
}
